export interface IUserInfo {
  userId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  country?: any;
  phoneNumber?: string;
  size?: any;
  company?: {
    columnHashingSal: string;
    name: string;
    companyId: number;
  };
  password?: string;
  productSigningUpFor?: string;
  annualRevenue?: string;
}
export enum AppState {
  REGISTER = 'REGISTER',
  SETUP = 'SETUP',
  LOGIN = 'LOGIN',
  RESET = 'RESET',
  AUTHENTICATED = 'AUTHENTICATED',
  NONE = 'NONE',
}
export enum Products {
  DATON = 'DATON',
  PULSE = 'INSIGHTS',
  INSIGHTS = 'INSIGHTS',
  GLOBAL = 'SARAS',
  SARAS = 'SARAS',
  IQ = 'IQ',
}
export const ProductTitle: any = {
  DATON: 'Daton',
  PULSE: 'Pulse',
  INSIGHTS: 'Pulse',
  SARAS: 'Saras',
  GLOBAL: 'Saras',
  IQ: 'Saras IQ',
};
export interface IState {
  user: IUserInfo;
  status: AppState;
  product?: Products;
  userId?: string;
}

export const PRODUCT_THEME: { [key: string]: string } = {
  DATON: 'daton-theme',
  PULSE: 'purple-theme',
  INSIGHTS: 'purple-theme',
  GLOBAL: 'saras-theme',
  SARAS: 'saras-theme',
  IQ: 'iq-theme',
};

export interface IAppParams {
  email?: string;
  firstName?: string;
  userId?: string;
  code?: string;
  product?: Products;
  redirectURL?: string;
  productType?: string;
  mode?: FirebaseMode | null;
  oobCode?: string;
  lang?: string;
  continueUrl?: string;
}

export interface IRedirectionConfig {
  currentProduct?: Products;
  newTab?: boolean;
  params?: {
    key: string;
    value: string;
  }[];
}

export enum FirebaseMode {
  resetPassword = 'resetPassword',
  recoverEmail = 'recoverEmail',
  verifyEmail = 'verifyEmail',
  unrollMFA = 'revertSecondFactorAddition',
}
